import { AuthGuard } from './guards/auth.guard';
import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';

const routes: Routes = [
  /* {
    path: 'recorte',
    canActivate: [AuthGuard],
    loadChildren:
      './pages/home-results/home-results.module#HomeResultsPageModule'
  }, */
  {
    path: 'detalhe-recorte/:id',
    canActivate: [AuthGuard],
    loadChildren:
      './pages/detalhe-recorte/detalhe-recorte.module#DetalheRecortePageModule'
  },
  {
    path: 'configuracoes',
    canActivate: [AuthGuard],
    loadChildren:
      './pages/configuracoes/configuracoes.module#ConfiguracoesPageModule'
  },
  {
    path: '',
    canActivate: [AuthGuard],
    loadChildren: './pages/tabs/tabs.module#TabsPageModule'
  },
  
  { path: 'boletim', loadChildren: './pages/boletim/boletim.module#BoletimPageModule' },
  { path: 'lista-processos', loadChildren: './pages/lista-processos/lista-processos.module#ListaProcessosPageModule' },
  { path: 'detalhe-processo/:nCdMonitoramento', loadChildren: './pages/detalhe-processo/detalhe-processo.module#DetalheProcessoPageModule' }
  ,{
    path: '**',
    canActivate: [AuthGuard],
    loadChildren: './pages/login/login.module#LoginPageModule'
  },

];

@NgModule({
  imports: [RouterModule.forRoot(routes)],
  exports: [RouterModule]
})
export class AppRoutingModule {}
